// extracted by mini-css-extract-plugin
module.exports = {"icon":"BatteryStatus_icon__zldZk","label":"BatteryStatus_label__28rp6"};